export const ValidationMessages = {
    alpha: "Alphanumeric characters only.",
    minLength: "Must have a length no less than {{min}}.",
    required: "Required field.",
    sameAsPassword: "Password fields must match.",
    termsValidate: "Must agree with Terms and Conditions to continue.",
    privacyValidate: "Must read the Privacy Policy to continue.",
};

